import { types, applySnapshot} from "mobx-state-tree";
import { Framework } from "@flint/framework";

const EPubUploadModel = types
  .model("EPubUploadModel", {
    res: types.string,
  })
  .actions((self) => ({
    fetch(term) {
      Framework.sendEvent("UPLOAD_EPUB", { term });
    },
    set(response) {
      let data;
      if (response.data.response === "EPUB EXIST") {
        data =
          "The ePub file you are trying to upload already exists.";
      } else if (response.data.response === "SUCCESS") {
        data = "The ePub file upload request has been submitted successfully. Please check HOME PAGE after some time.";
      } else {
        data = response.data.response;
      }
      applySnapshot(self, {
        res: data,
      });
    },
    reset() {
      applySnapshot(self, {
        res: "Oops...Something went wrong. Please try again.",
      });
    },
  }));

export default EPubUploadModel;
